import { chains, } from ".";

export const tokenExists = ( name: string, chainId?: number, ): boolean => {

	return Object.entries(chains).some(([id, chain]) => {
		if(chainId && chainId !== Number(id)) return false;
		const definition = chain.tokenDefinitions.find(def => name.toUpperCase() === def.symbol);
		if(definition && definition.disabled !== true) {
			return definition;
		}
	});

}
